import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReviewResponseService } from '../services/review-response.service';

@Component({
  selector: 'app-edit-review-response',
  templateUrl: './edit-review-response.component.html',
  styleUrls: ['./edit-review-response.component.scss']
})
export class EditReviewResponseComponent implements OnInit {
  entityId: number;
  reviewId: number;
  isAirport = false;
  formGroup: FormGroup;
  selectedResponse: string;

  constructor(private _matDialogRef: MatDialogRef<EditReviewResponseComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _responseService: ReviewResponseService
              ) {
    this.entityId = data.entityId;
    this.reviewId = data.reviewId;
    this.isAirport = data.isAirport;
    this.selectedResponse = data.response;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      responseText: new FormControl(this.selectedResponse, [Validators.maxLength(2000)])
    });
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      res = await this._responseService.putReviewResponse(this.entityId, this.isAirport, this.reviewId, this.selectedResponse);
      this.close({cancelBtnClicked: false, success: true});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    this._matDialogRef.close(data);
  }

}
